import { render, staticRenderFns } from "./addresPop.vue?vue&type=template&id=21b9c1d5&scoped=true&"
import script from "./addresPop.vue?vue&type=script&lang=js&"
export * from "./addresPop.vue?vue&type=script&lang=js&"
import style0 from "./addresPop.vue?vue&type=style&index=0&id=21b9c1d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9c1d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b9c1d5')) {
      api.createRecord('21b9c1d5', component.options)
    } else {
      api.reload('21b9c1d5', component.options)
    }
    module.hot.accept("./addresPop.vue?vue&type=template&id=21b9c1d5&scoped=true&", function () {
      api.rerender('21b9c1d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseOrder/components/addresPop.vue"
export default component.exports